import { Button } from "antd";
import { useIntl } from "react-intl";
import { ProductSVG } from "../../assets/SVGs/SVGs";
import SubInfo from "../admin/common/SubInfo";

type Props = { products: any; setProducts: any; currentStep: number };
const deleteIconSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M9.07544 4.57248L8.92544 9.1126C8.91266 9.50144 8.74886 9.86999 8.4688 10.14C8.18875 10.4101 7.81448 10.5604 7.42544 10.559H4.57544C4.18665 10.5604 3.8126 10.4103 3.53258 10.1406C3.25256 9.87085 3.0886 9.50268 3.07544 9.1141L2.92544 4.57248C2.92216 4.47302 2.95852 4.37634 3.02652 4.30369C3.09453 4.23104 3.18861 4.18839 3.28806 4.1851C3.38752 4.18182 3.48421 4.21818 3.55685 4.28619C3.6295 4.35419 3.67216 4.44827 3.67544 4.54773L3.82544 9.08898C3.83291 9.28284 3.91521 9.46627 4.05506 9.60074C4.19491 9.73521 4.38143 9.81025 4.57544 9.8101H7.42544C7.6197 9.81023 7.80643 9.73498 7.94632 9.6002C8.08621 9.46541 8.16835 9.28161 8.17544 9.08748L8.32544 4.54773C8.32872 4.44827 8.37138 4.35419 8.44402 4.28619C8.51667 4.21818 8.61336 4.18182 8.71281 4.1851C8.81227 4.18839 8.90635 4.23104 8.97435 4.30369C9.04236 4.37634 9.07872 4.47302 9.07544 4.57248ZM9.57156 3.0616C9.57156 3.16106 9.53205 3.25644 9.46173 3.32677C9.3914 3.39709 9.29602 3.4366 9.19656 3.4366H2.80469C2.70523 3.4366 2.60985 3.39709 2.53952 3.32677C2.4692 3.25644 2.42969 3.16106 2.42969 3.0616C2.42969 2.96215 2.4692 2.86676 2.53952 2.79644C2.60985 2.72611 2.70523 2.6866 2.80469 2.6866H3.96719C4.08601 2.68692 4.20069 2.64303 4.28893 2.56345C4.37717 2.48388 4.43264 2.37432 4.44456 2.2561C4.47224 1.97879 4.60216 1.7217 4.80902 1.53494C5.01589 1.34818 5.28487 1.24513 5.56356 1.24585H6.43731C6.71601 1.24513 6.98499 1.34818 7.19185 1.53494C7.39871 1.7217 7.52864 1.97879 7.55631 2.2561C7.56823 2.37432 7.62371 2.48388 7.71194 2.56345C7.80018 2.64303 7.91487 2.68692 8.03369 2.6866H9.19619C9.29564 2.6866 9.39103 2.72611 9.46135 2.79644C9.53168 2.86676 9.57119 2.96215 9.57119 3.0616H9.57156ZM5.09556 2.6866H6.90606C6.85678 2.57401 6.82456 2.4547 6.81044 2.3326C6.80115 2.24017 6.75788 2.15447 6.68901 2.09212C6.62015 2.02977 6.53059 1.9952 6.43769 1.9951H5.56394C5.47104 1.9952 5.38148 2.02977 5.31261 2.09212C5.24375 2.15447 5.20048 2.24017 5.19119 2.3326C5.17695 2.45472 5.14497 2.57403 5.09556 2.6866ZM5.47319 8.36823V5.1751C5.47319 5.07565 5.43368 4.98026 5.36335 4.90994C5.29303 4.83961 5.19764 4.8001 5.09819 4.8001C4.99873 4.8001 4.90335 4.83961 4.83302 4.90994C4.7627 4.98026 4.72319 5.07565 4.72319 5.1751V8.36973C4.72319 8.46918 4.7627 8.56457 4.83302 8.63489C4.90335 8.70522 4.99873 8.74473 5.09819 8.74473C5.19764 8.74473 5.29303 8.70522 5.36335 8.63489C5.43368 8.56457 5.47319 8.46918 5.47319 8.36973V8.36823ZM7.27844 8.36823V5.1751C7.27844 5.07565 7.23893 4.98026 7.1686 4.90994C7.09828 4.83961 7.00289 4.8001 6.90344 4.8001C6.80398 4.8001 6.7086 4.83961 6.63827 4.90994C6.56795 4.98026 6.52844 5.07565 6.52844 5.1751V8.36973C6.52844 8.46918 6.56795 8.56457 6.63827 8.63489C6.7086 8.70522 6.80398 8.74473 6.90344 8.74473C7.00289 8.74473 7.09828 8.70522 7.1686 8.63489C7.23893 8.56457 7.27844 8.46918 7.27844 8.36973V8.36823Z"
      fill="#C43535"
    />
  </svg>
);

const ListSoldProducts = ({ products, setProducts, currentStep }: Props) => {
  const intl = useIntl();

  const handleChangePrductQty = (
    productId: number,
    type: "increase" | "decrease"
  ) => {
    if (type === "increase") {
      const newProducts = products.map((product: any) => {
        if (product.id === productId) {
          return {
            ...product,
            quantity: product.quantity + 1,
          };
        }
        return product;
      });
      setProducts(newProducts);
    } else if (type === "decrease") {
      const newProducts = products.map((product: any) => {
        if (product.id === productId) {
          return {
            ...product,
            quantity: product.quantity - 1,
          };
        }
        return product;
      });
      setProducts(newProducts);
    }
  };
  const removeProductsItem = (index: number) => {
    const newProducts = products.filter((_: any, i: number) => i !== index);
    setProducts(newProducts);
  };

  return (
    <div className="flex flex-col gap-2">
      {/* {products ? (
        <p className="text-sx text-[#75757E]">المنتجات المضافة:</p>
      ) : null} */}
      {products.map((product: any, index: any) => {
        return (
          <div
            className="flex gap-2 justify-between bg-[#FBFBFF] p-2  rounded"
            key={index}
          >
            <p className="flex items-center gap-2">
              <span>{ProductSVG}</span>
              <span>{product?.name}</span>
            </p>
            <SubInfo
              value={product?.retail_price}
              label={intl.formatMessage({
                id: "SAR",
                defaultMessage: "ريال سعودي",
              })}
            />
            <div className="flex gap-1">
              {currentStep <= 2 ? (
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => {
                    handleChangePrductQty(product.id, "increase");
                  }}
                >
                  +
                </Button>
              ) : null}
              <p className="p-2 px-3 text-center bg-white">
                {product?.quantity || 1}
              </p>
              {currentStep <= 2 ? (
                product?.quantity > 1 ? (
                  <Button
                    type="default"
                    htmlType="button"
                    onClick={() => {
                      handleChangePrductQty(product.id, "decrease");
                    }}
                  >
                    -
                  </Button>
                ) : (
                  <Button
                    type="text"
                    htmlType="button"
                    onClick={() => {
                      removeProductsItem(index);
                    }}
                  >
                    {deleteIconSVG}
                  </Button>
                )
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ListSoldProducts;
